import React from 'react';
import { Form, Select, DatePicker, TimePicker, Switch, Row, Col, Input, Card, Spin } from 'antd';
import { UserOutlined, CarOutlined } from '@ant-design/icons';
import { SINISTER_COLORS } from '../../../../../components/ui/colors';
import dayjs from 'dayjs';

const listeDesCategoriesDePermis = ['AM', 'A1', 'A2', 'A', 'B', 'BE', 'C1', 'C', 'D1', 'D'].map(v => ({ value: v, label: v }));

const AssureStep = ({
    contratsLoading, contratsData, engins,
    isAssureConducteur, setIsAssureConducteur,
    cityOptions, selectedContratObj,
    onContratChange, onSearchContrats, onDateChange,
    form,
}) => (
    <Card style={{ borderRadius: 16, boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}>
        <div style={{ background: SINISTER_COLORS.primary, padding: '10px 30px', margin: '-24px -24px 24px -24px', borderRadius: '6px 6px 0 0' }}>
            <h2 style={{ color: '#fff', margin: 0, fontSize: 20, fontWeight: 'bold' }}>
                <UserOutlined style={{ marginRight: 12 }} />Informations sur l'Assuré et le Véhicule
            </h2>
        </div>
        <Row gutter={16}>
            <Col xs={24} sm={12}>
                <Form.Item label={<b>Contrat</b>} name="contratCodeId" rules={[{ required: true, message: 'Sélectionnez un contrat' }]}>
                    <Select placeholder="Rechercher un contrat" showSearch filterOption={false} loading={contratsLoading}
                        onSearch={onSearchContrats} onChange={onContratChange}
                        notFoundContent={contratsLoading ? <Spin size="small" /> : 'Aucun contrat trouvé'}
                        options={contratsData} />
                </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
                <Form.Item label={<b>Véhicule sinistré</b>} name="enginId" rules={[{ required: true, message: 'Sélectionnez un véhicule' }]}>
                    <Select placeholder="Sélectionner le véhicule" options={engins} />
                </Form.Item>
            </Col>
        </Row>
        <Row gutter={16}>
            <Col xs={24} sm={12}>
                <Form.Item label={<b>Date de survenance</b>} name="dateSurvenance"
                    rules={[
                        { required: true, message: 'Date requise' },
                        {
                            validator: (_, value) => {
                                if (!value) return Promise.resolve();
                                const heure = form.getFieldValue('heureSurvenance');
                                const { dateEffet, dateEcheance } = selectedContratObj || {};
                                const dt = value.clone();
                                if (heure) dt.hour(heure.hour()).minute(heure.minute());
                                if (dt.isAfter(new Date())) return Promise.reject('La date ne peut pas être dans le futur');
                                if (dateEffet && dateEcheance) {
                                    const e = dayjs(dateEffet), ec = dayjs(dateEcheance);
                                    if (dt.isBefore(e) || dt.isAfter(ec))
                                        return Promise.reject(`Entre le ${e.format('DD/MM/YYYY')} et le ${ec.format('DD/MM/YYYY')}`);
                                }
                                return Promise.resolve();
                            }
                        }
                    ]}>
                    <DatePicker disabledDate={c => c && c > new Date()} style={{ width: '100%' }} onChange={onDateChange} />
                </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
                <Form.Item label={<b>Heure de survenance</b>} name="heureSurvenance" rules={[{ required: true, message: 'Heure requise' }]}>
                    <TimePicker style={{ width: '100%' }} format="HH:mm" placeholder="Sélectionner l'heure" />
                </Form.Item>
            </Col>
        </Row>
        <Form.Item label={<b>L'assuré était-il le conducteur ?</b>}>
            <Switch checked={isAssureConducteur} onChange={setIsAssureConducteur}
                checkedChildren="Oui" unCheckedChildren="Non"
                style={{ background: isAssureConducteur ? '#52c41a' : '#d9d9d9' }} />
        </Form.Item>
        <div style={{ background: 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)', padding: 16, borderRadius: 6, marginTop: 16 }}>
            <h4 style={{ color: '#1565c0', marginBottom: 16 }}>
                <CarOutlined style={{ marginRight: 8 }} />Informations sur le {isAssureConducteur ? "permis de l'assuré" : 'conducteur'}
            </h4>
            {!isAssureConducteur && (
                <Row gutter={16}>
                    <Col xs={24} sm={12}><Form.Item label={<b>Nom du conducteur</b>} name={['conducteur', 'nom']} rules={[{ required: true }]}><Input placeholder="Nom" /></Form.Item></Col>
                    <Col xs={24} sm={12}><Form.Item label={<b>Prénom du conducteur</b>} name={['conducteur', 'prenom']} rules={[{ required: true }]}><Input placeholder="Prénom" /></Form.Item></Col>
                    <Col xs={24} sm={12}><Form.Item label={<b>Téléphone</b>} name={['conducteur', 'telephone']}><Input /></Form.Item></Col>
                    <Col xs={24} sm={12}><Form.Item label={<b>Adresse</b>} name={['conducteur', 'adresse']}><Input /></Form.Item></Col>
                </Row>
            )}
            <Row gutter={16}>
                <Col xs={24} sm={12}><Form.Item label={<b>Numéro de permis</b>} name={['permis', 'numero']}><Input placeholder="Numéro de permis" /></Form.Item></Col>
                <Col xs={24} sm={12}><Form.Item label={<b>Catégorie de permis</b>} name={['permis', 'categorie']}><Select options={listeDesCategoriesDePermis} placeholder="Catégorie" /></Form.Item></Col>
                <Col xs={24} sm={12}><Form.Item label={<b>Date d'obtention</b>} name={['permis', 'dateObtention']}><DatePicker disabledDate={c => c && c > new Date()} style={{ width: '100%' }} /></Form.Item></Col>
                <Col xs={24} sm={12}><Form.Item label={<b>Lieu d'obtention</b>} name={['permis', 'lieuObtention']}><Select options={cityOptions} style={{ width: '100%' }} /></Form.Item></Col>
            </Row>
        </div>
    </Card>
);

export default AssureStep;
